/// <reference path="app.ts" />

namespace Cfnc {
    "use strict";

    export interface IRouteConfigSetting {
        nav?: number;
        content?: string;
        parent?: string;
        breadCrumb?: string;
        parentUrl?: string;
        // showBreadcrumbs value defaults to true
        showBreadcrumbs?: boolean; 
    }

    export interface IRouteConfig {
        templateUrl: string;
        title: string;
        settings: IRouteConfigSetting;
        caseInsensitiveMatch?: boolean;
        reloadOnSearch?: boolean;
        reloadOnUrl?: boolean;
        redirectTo?: any;
    }

    export interface IRoute {
        url: string;
        config: IRouteConfig;
    }

    class Routes {

        static getRoutes(): Array<IRoute> {
            var routes: Array<IRoute>;

            routes = [
                // #region internal routes
                {
                    url: "/signin-callback",
                    config: {
                        templateUrl: "/app/account/signInRedirectCallBack.html",
                        caseInsensitiveMatch: true,
                        title: "SignIn",
                        settings: {
                            parent: "Home",
                            breadCrumb: "Login"
                        }
                    }
                }, {
                    url: "/signout-callback",
                    config: {
                        templateUrl: "/app/account/signOutRedirectCallBack.html",
                        caseInsensitiveMatch: true,
                        title: "SignOut",
                        settings: {
                            parent: "Home",
                            breadCrumb: "SignOut"
                        }
                    }
                },
                {
                    url: "/",
                    config: {
                        templateUrl: "/app/home/home.html",
                        caseInsensitiveMatch: true,
                        title: "",
                        settings: {
                            nav: 1,
                            content: "<i class='fa fa-dashboard'></i> Home"
                        }
                    }
                }, {
                    url: "/resetPasswordConfirmation",
                    config: {
                        templateUrl: "/app/account/resetPasswordConfirmation.html",
                        caseInsensitiveMatch: true,
                        title: "Reset Password Confirmation",
                        settings: {
                            nav: 2,
                            content: "Reset Password Confirmation",
                            parent: "Home",
                            breadCrumb: "Recover Account"

                        }
                    }
                }, {
                    url: "/resetPassword",
                    config: {
                        templateUrl: "/app/account/resetPasswordWithToken.html",
                        caseInsensitiveMatch: true,
                        title: "Reset Password",
                        reloadOnSearch: false,
                        settings: {
                            nav: 2,
                            content: "Reset Password",
                            parent: "Home",
                            breadCrumb: "Reset Password"
                        }
                    }
                }, {
                    url: "/apphub",
                    config: {
                        templateUrl: "/app/apphub/apphub.html",
                        caseInsensitiveMatch: true,
                        title: "Application Hub",
                        settings: {
                            nav: 3,
                            content: "app hub",
                            parent: "Apply to College",
                            breadCrumb: "Application Hub"
                        }
                    }
                }, {
                    url: "/college-search",
                    config: {
                        templateUrl: "/app/campusSearch/campusSearch.html",
                        caseInsensitiveMatch: true,
                        title: "College Search",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        settings: {
                            nav: 3,
                            content: "College Search",
                            parent: "Plan for College",
                            breadCrumb: "College Search"
                        }
                    }

                }, {
                    url: "/apphub/requesttranscript",
                    config: {
                        templateUrl: "/app/apphub/requesttranscript.html",
                        caseInsensitiveMatch: true,
                        title: "Request Transcripts",
                        settings: {
                            nav: 5,
                            content: "send transcript",
                            parent: "Apply to College",
                            breadCrumb: "Request Transcripts"

                        }
                    }
                },
                {
                    url: "/exploreprogramsandmajors/schoolofferingprogram/:programId",
                    config: {
                        templateUrl: "/app/exploreProgramsAndMajors/schoolOfferingProgram.html",
                        caseInsensitiveMatch: true,
                        title: "Schools Offering This Program",
                        settings: {
                            nav: 6,
                            content: "Schools Offering This Program",
                            parent: "Plan for College",
                            parentUrl: "",
                            breadCrumb: "Explore Programs and Majors"
                        }
                    }
                },
                {
                    url: "/college-profile/:institutionName/",
                    config: {
                        templateUrl: "/app/campusProfile/campusProfile.html",
                        caseInsensitiveMatch: true,
                        title: ":institutionName",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        settings: {
                            nav: 6,
                            content: "",
                            parent: "College Search",
                            breadCrumb: ":institutionName"
                        }
                    }
                },
                {
                    url: "/college-profile/:institutionName/:section",
                    config: {
                        templateUrl: "/app/campusProfile/campusProfile.html",
                        caseInsensitiveMatch: true,
                        title: ":institutionName",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        settings: {
                            nav: 6,
                            content: "",
                            parent: ":institutionName",
                            breadCrumb: ":section",
                        }
                    }
                },
                {
                    url: "/collegePlanning",
                    config: {
                        templateUrl: "/app/collegePlanning/collegePlanning.html",
                        caseInsensitiveMatch: true,
                        title: "College Planning",
                        settings: {
                            content: "College Planning",
                            parent: "MyCfnc"
                        }
                    }
                },
                {
                    url: "/taap",
                    config: {
                        templateUrl: "/app/taap/taap.html",
                        caseInsensitiveMatch: true,
                        title: "Transfer Assured Admissions Policy Overview",
                        settings: {
                            nav: 9,
                            content: "Transfer Assured Admissions Policy Overview",
                            parent: "Transfer Student Planner",
                            breadCrumb: "Transfer Assured Admissions Policy Overview"
                        }
                    }
                },
                {
                    url: "/uncInstitutions",
                    config: {
                        templateUrl: "/app/taap/uncSchools.html",
                        caseInsensitiveMatch: true,
                        title: "UNC Institutions Participating in TAAP",
                        settings: {
                            nav: 10,
                            content: "UNC Institutions",
                            parent: "Transfer Student Planner",
                            breadCrumb: "UNC Institutions"
                        }
                    }
                },
                {
                    url: "/taapform",
                    config: {
                        templateUrl: "/app/taap/taapForm.html",
                        caseInsensitiveMatch: true,
                        title: "Transfer Assured Admissions Policy Registration",
                        settings: {
                            nav: 10,
                            content: "Transfer Assured Admissions Policy Registration",
                            parent: "Transfer Student Planner",
                            breadCrumb: "Transfer Assured Admissions Policy Registration"
                        }
                    }
                },
                {
                    url: "/CRP",
                    config: {
                        templateUrl: "/app/CRP/CRPLandingPage.html",
                        caseInsensitiveMatch: true,
                        title: "College Redirection Pool",
                        settings: {
                            nav: 11,
                            content: "CRP Landing Page",
                            parent: "Planning Resources",
                            breadCrumb: "College Redirection Pool"
                        }
                    }
                },
                {
                    url: "/CollegeRedirection",
                    config: {
                        templateUrl: "/app/CRP/crp.html",
                        caseInsensitiveMatch: true,
                        title: "College Redirection Pool Registration",
                        settings: {
                            nav: 12,
                            content: "CRP",
                            parent: "Planning Resources",
                            breadCrumb: "College Redirection Pool Registration"
                        }
                    }
                },
                {
                    url: "/collegeRecruiter",
                    config: {
                        templateUrl: "/app/collegeRecruiter/collegeRecruiter.html",
                        caseInsensitiveMatch: true,
                        title: "Get Recruited",
                        settings: {
                            nav: 13,
                            content: "College Recruiter",
                            parent: "Apply to College",
                            breadCrumb: "Get Recruited"
                        }
                    }
                },
                {
                    url: "/profile",
                    config: {
                        templateUrl: "/app/profile/profile.html",
                        caseInsensitiveMatch: true,
                        title: "Profile",
                        settings: {
                            nav: 13,
                            content: "Your Profile",
                            parent: null,
                            breadCrumb: null,
                            showBreadcrumbs: false
                        }
                    }
                }, {
                    url: "/testScores",
                    config: {
                        templateUrl: "/app/testScores/testScores.html",
                        caseInsensitiveMatch: true,
                        title: "Test Scores",
                        settings: {
                            nav: 13,
                            content: "Test Scores",
                            parent: "MyCfnc"
                        }
                    }
                }, {
                    url: "/activitiesInterests",
                    config: {
                        templateUrl: "/app/activitiesInterests/activitiesInterests.html",
                        caseInsensitiveMatch: true,
                        title: "Activities and Interests",
                        settings: {
                            nav: 13,
                            content: "Activities and Interests",
                            parent: "MyCfnc"
                        }
                    }
                }, {
                    url: "/testPrep",
                    config: {
                        templateUrl: "/app/testPrep/testPrep.html",
                        caseInsensitiveMatch: true,
                        title: "Test Preperation",
                        settings: {
                            nav: 14,
                            content: "Test Prep",
                            parent: "Planning Resources",
                            breadCrumb: "Test Preperation"
                        }
                    }
                }, {
                    url: "/studentCalendar",
                    config: {
                        templateUrl: "/app/studentCalendar/studentCalendar.html",
                        title: "Student Calendar",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "MyCfnc"
                        }
                    }
                },

                //learn-about-yourself renaming
                {
                    url: "/learn-about-yourself",
                    config: {
                        templateUrl: "/app/learnAboutYourself/assessments.html",
                        title: "Learn About Yourself",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Plan for a Career",
                            breadCrumb: "Learn About Yourself"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/interest-profiler",
                    config: {
                        templateUrl: "/app/learnAboutYourself/interestprofiler.html",
                        title: "Interest Profiler",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Interest Profiler"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/career-cluster-survey",
                    config: {
                        templateUrl: "/app/learnAboutYourself/careerclustersurvey.html",
                        title: "Career Cluster Survey",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Career Cluster Survey"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/basic-skills-survey",
                    config: {
                        templateUrl: "/app/learnAboutYourself/basicskillssurvey.html",
                        title: "Basic Skills Survey",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Basic Skills Survey"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/transferable-skills-survey",
                    config: {
                        templateUrl: "/app/learnAboutYourself/transferableskillschecklist.html",
                        title: "Transferable Skills Survey",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Transferable Skills Survey"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/the-career-key",
                    config: {
                        templateUrl: "/app/learnAboutYourself/theCareerKey.html",
                        title: "The Career Key",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "The Career Key"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/work-values-sorter",
                    config: {
                        templateUrl: "/app/learnAboutYourself/workvaluessorter.html",
                        title: "Work Values Sorter",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Work Values Sorter"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/be-your-own-boss",
                    config: {
                        templateUrl: "/app/learnAboutYourself/beyourownboss.html",
                        title: "Be Your Own Boss",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Be Your Own Boss"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/reality-check",
                    config: {
                        templateUrl: "/app/learnAboutYourself/realitycheck.html",
                        title: "Reality Check",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Reality Check"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/skills-matcher",
                    config: {
                        templateUrl: "/app/learnAboutYourself/skillsmatcher.html",
                        title: "Skills Matcher",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Skills Matcher"
                        }
                    }
                },

                {
                    url: "/learnAboutYourself",
                    config: {
                        templateUrl: "/app/learnAboutYourself/assessments.html",
                        title: "Learn About Yourself",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Plan for a Career",
                            breadCrumb: "Learn About Yourself"
                        }
                    }
                },  {
                    url: "/learnAboutYourself/interest-profiler",
                    config: {
                        templateUrl: "/app/learnAboutYourself/interestprofiler.html",
                        title: "Interest Profiler",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Interest Profiler"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/career-cluster-survey",
                    config: {
                        templateUrl: "/app/learnAboutYourself/careerclustersurvey.html",
                        title: "Career Cluster Survey",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Career Cluster Survey"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/basic-skills-survey",
                    config: {
                        templateUrl: "/app/learnAboutYourself/basicskillssurvey.html",
                        title: "Basic Skills Survey",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Basic Skills Survey"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/transferable-skills-survey",
                    config: {
                        templateUrl: "/app/learnAboutYourself/transferableskillschecklist.html",
                        title: "Transferable Skills Survey",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Transferable Skills Survey"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/the-career-key",
                    config: {
                        templateUrl: "/app/learnAboutYourself/theCareerKey.html",
                        title: "The Career Key",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "The Career Key"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/work-values-sorter",
                    config: {
                        templateUrl: "/app/learnAboutYourself/workvaluessorter.html",
                        title: "Work Values Sorter",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Work Values Sorter"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/be-your-own-boss",
                    config: {
                        templateUrl: "/app/learnAboutYourself/beyourownboss.html",
                        title: "Be Your Own Boss",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Be Your Own Boss"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/reality-check",
                    config: {
                        templateUrl: "/app/learnAboutYourself/realitycheck.html",
                        title: "Reality Check",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Reality Check"
                        }
                    }
                }, {
                    url: "/learnAboutYourself/skills-matcher",
                    config: {
                        templateUrl: "/app/learnAboutYourself/skillsmatcher.html",
                        title: "Skills Matcher",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "Skills Matcher"
                        }
                    }
                },
                

                // route for Human eSources assessments
                {
                    url: "/learnAboutYourself/:assessment",
                    config: {
                        templateUrl: "/app/learnAboutYourself/heSAssessments.html",
                        title: "AchieveWorks Assessments",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "AchieveWorks Assessments"
                        }
                    }
                }, {
                    url: "/learn-about-yourself/:assessment",
                    config: {
                        templateUrl: "/app/learnAboutYourself/heSAssessments.html",
                        title: "AchieveWorks Assessments",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Learn About Yourself",
                            breadCrumb: "AchieveWorks Assessments"
                        }
                    }
                },


                {
                    url: "/recoverAccount/:option",
                    config: {
                        templateUrl: "/app/account/recoverAccount.html",
                        title: "Recover Account",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Home",
                            breadCrumb: "Recover Account"
                        }
                    }
                }, {
                    url: "/transcriptSchools",
                    config: {
                        templateUrl: "/app/transcriptSchools/transcriptSchools.html",
                        title: "Schools That Provide e-Transcripts",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "College Application Resources",
                            breadCrumb: "Schools That Provide e-Transcripts"
                        }
                    }
                }, {
                    url: "/orders",
                    config: {
                        templateUrl: "/app/orders/submitorder.html",
                        title: "Order Materials",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Home",
                            breadCrumb: "Order Materials"
                        }
                    }
                }, {
                    url: "/careers/",
                    config: {
                        templateUrl: "/app/careers/careersearch.html",
                        title: "Careers",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Plan for a Career",
                            breadCrumb: "Careers"
                        }
                    }
                }, {
                    url: "/careers/:occupation",
                    config: {
                        templateUrl: "/app/careers/careerdetails.html",
                        title: ":occupation",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Careers",
                            breadCrumb: ":occpuation"
                        }
                    }
                }, {
                    url: "/programsMajors/",
                    config: {
                        templateUrl: "/app/exploreProgramsAndMajors/programsMajorsSearch.html",
                        title: "Programs and Majors",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Plan for College",
                            breadCrumb: "Programs and Majors"
                        }
                    }
                }, {
                    url: "/programsMajors/:program",
                    config: {
                        templateUrl: "/app/exploreProgramsAndMajors/programDetails.html",
                        title: ":program",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Plan for College",
                            breadCrumb: ":program"
                        }
                    }
                }, {
                    url: "/StudentEnrichment",
                    config: {
                        templateUrl: "/app/studentEnrichment/studentEnrichment.html",
                        title: "Pre-College Enrichment Programs",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Plan for College",
                            breadCrumb: "Pre-College Enrichment Programs"
                        }
                    }
                }, {
                    url: "/savedColleges",
                    config: {
                        templateUrl: "/app/collegePlanning/SavedColleges.html",
                        title: "Saved Colleges",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "My Account",
                            breadCrumb: "Saved Colleges",
                            showBreadcrumbs: false
                        }
                    }
                },{
                    url: "/savedPrograms",
                    config: {
                        templateUrl: "/app/exploreProgramsAndMajors/SavedProgramsMajors.html",
                        title: "Saved Programs",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "My Account",
                            breadCrumb: "Saved Programs",
                            showBreadcrumbs: false
                        }
                    }
                },{
                    url: "/sample",
                    config: {
                        templateUrl: "/app/sample.html",
                        title: "sample",
                        caseInsensitiveMatch: true,
                        settings: {
                        }
                    }
                },
                // #endregion

                // #region redirect routes
                {
                    url: "/institutions/:institutionId/campusprofile",
                    config: {
                        title: "College Profile",
                        templateUrl: null,
                        caseInsensitiveMatch: true,
                        redirectTo: (params) => {
                            return `/college-profile/${InstitutionMapper.getMap()[params.institutionId]}`
                        },
                        settings: {}
                    }
                },

                // #endregion

                // #region external routes
                // The following routes exist for the use in breadcrumbs.
                {
                    url: "[umbraco]/plan-your-future/plan-for-college",
                    config: {
                        templateUrl: null,
                        title: "Plan for College",
                        settings: {
                            parent: "Plan Your Future",
                            breadCrumb: "Plan for College"
                        }
                    }
                },
                {
                    url: "[umbraco]/plan-your-future",
                    config: {
                        templateUrl: null,
                        title: "Plan Your Future",
                        settings: {
                            parent: "Home",
                            breadCrumb: "Plan Your Future"
                        }
                    }
                },
                {
                    url: "[umbraco]/plan-your-future/plan-for-a-career",
                    config: {
                        templateUrl: null,
                        title: "Plan for a Career",
                        settings: {
                            parent: "Plan Your Future",
                            breadCrumb: "Plan for a Career"
                        }
                    }
                },
                {
                    url: "[umbraco]/pay-for-college",
                    config: {
                        templateUrl: null,
                        title: "Pay for College",
                        settings: {
                            parent: "Home",
                            breadCrumb: "Pay For College"
                        }
                    }
                },
                {
                    url: "[umbraco]/save-for-college",
                    config: {
                        templateUrl: null,
                        title: "Save for College",
                        settings: {
                            parent: "Home",
                            breadCrumb: "Save for College"
                        }
                    }
                },
                {
                    url: "[umbraco]/pay-for-college",
                    config: {
                        templateUrl: null,
                        title: "Pay for College",
                        settings: {
                            parent: "Plan Your Future",
                            breadCrumb: "Play for College"
                        }
                    }
                },
                {
                    url: "[umbraco]/plan-your-future/planning-resources",
                    config: {
                        templateUrl: null,
                        title: "Planning Resources",
                        settings: {
                            parent: "Plan Your Future",
                            breadCrumb: "Planning Resources"
                        }
                    }
                }, {
                    url: "[umbraco]/apply-to-college",
                    config: {
                        templateUrl: null,
                        title: "Apply to College",
                        settings: {
                            parent: "Home",
                            breadCrumb: "Apply to College"
                        }
                    }
                }, {
                    url: "[umbraco]/apply-to-college/college-application-resources",
                    config: {
                        templateUrl: null,
                        title: "College Application Resources",
                        settings: {
                            parent: "Apply to College",
                            breadCrumb: "College Application Resources"
                        }
                    }
                }, {
                    url: "[umbraco]/plan-your-future/plan-for-college/transfer-student-planner",
                    config: {
                        templateUrl: null,
                        title: "Transfer Student Planner",
                        settings: {
                            parent: "Plan for College",
                            breadCrumb: "Transfer Student Planner"
                        }
                    }
                },
                {
                    url: "/exclusive/applicationLogin/:organization/:program/:appKey",
                    config: {
                        templateUrl: "/app/exclusive/login.html",
                        title: "Log On",
                        caseInsensitiveMatch: true,
                        settings: {}
                    }
                },
                {
                    url: "/exclusive.html/applicationLogin/:organization/:program/:appKey",
                    config: {
                        templateUrl: "/app/exclusive/login.html",
                        title: "Log On",
                        caseInsensitiveMatch: true,
                        settings: {}
                    }
                },
                {
                    url:"/externalContent",
                    config: {
                        templateUrl: "/app/externalContent/externalContent.html",
                        title: "Text External Content",
                        caseInsensitiveMatch: true,
                        settings: {}
                    }
                },
                {
                    url: "/next-step/",
                    config: {
                        templateUrl: "/app/nextSteps/nextStepsOverview.html",
                        title: "Next Step",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Home",
                            breadCrumb: "Next Step"
                        }
                    }
                },
                {
                    url: "/next-step/students-and-parents",
                    config: {
                        templateUrl: "/app/nextSteps/nextStepsOverviewStudentsAndParents.html",
                        title: "Next Step for Students & Parents/Guardians",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Next Step",
                            breadCrumb: ""
                        }
                    }
                },
                {
                    url: "/next-step/educators",
                    config: {
                        templateUrl: "/app/nextSteps/nextStepsOverviewEducators.html",
                        title: "Next Step for Educators",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Next Step",
                            breadCrumb: ""
                        }
                    }
                },
                {
                    url: "/next-step/courses",
                    config: {
                        templateUrl: "/app/nextSteps/nextStepsLandingPage.html",
                        title: "Next Step Courses",
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Next Step",
                            breadCrumb: "Next Step Courses"
                        }
                    }
                },
                {
                    url: "/next-step/:pathway",
                    config: {
                        templateUrl: "/app/nextSteps/nextStepsPathway.html",
                        title: ":pathway Pathway",
                        reloadOnSearch: false,
                        reloadOnUrl: false,
                        caseInsensitiveMatch: true,
                        settings: {
                            parent: "Next Step Courses",
                            breadCrumb: ":pathway Pathway"
                        }
                    }
                }, {
                    url: "/collegeConnect",
                    config: {
                        templateUrl: "/app/directAdmission/directAdmissions.html",
                        caseInsensitiveMatch: true,
                        title: "NC College Connect",
                        settings: {
                            parent: "Apply to College",
                            breadCrumb: "NC College Connect"
                        }
                    }
                }
                
                // #endregion
            ];

            return routes;
        }
    }

    

    class RouteConfigurator {

        constructor(private $routeProvider: ng.route.IRouteProvider, private routes: Array<IRoute>) {
            var config = new Config();
            routes.forEach((r: IRoute): void => {
                r.url = r.url.replace("[umbraco]", config.umbracoUrl);

                $routeProvider.when(r.url, r.config);
            });
            

            $routeProvider.otherwise({ redirectTo: "/" });
        }
    }

    angular.module("app").constant("routes", Routes.getRoutes());
    angular.module("app").config(["$routeProvider", "routes", ($routeProvider, routes) =>
        new RouteConfigurator($routeProvider, routes)
    ]);
} 